import { Calendar as FCalendar } from "@fullcalendar/core"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin from "@fullcalendar/interaction"
import listPlugin from "@fullcalendar/list"
import timeGridPlugin from "@fullcalendar/timegrid"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import ToggleButton from "@mui/material/ToggleButton"
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup"
import "./calendar.css"
import { Stack } from "@mui/material"
import Timetable from "../components/common/Timetable"

const timings = [
  "09:00 - 10:00",
  "10:00 - 11:00",
  "11:00-12:00",
  "12:00-13:00",
  "13:00-14:00",
]
const schedule = [
  [
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
    {
      name: "Break",
    },
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
  ],
  [
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
    {
      name: "Break",
    },
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
  ],
  [
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
    {
      name: "Break",
    },
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
  ],
  [
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
    {
      name: "Break",
    },
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
  ],
  [
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
    {
      name: "Break",
    },
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
  ],
  [
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
    {
      name: "Break",
    },
    {
      name: "Maths",
    },
    {
      name: "Maths",
    },
  ],
]

const Calendar = () => {
  const [view, setView] = useState("Timetable")
  const handleChange = (_, newView) => setView(newView)

  return (
    <>
      <Stack direction="row" justifyContent="center" sx={{ mb: 3 }}>
        <ToggleButtonGroup
          color="primary"
          value={view}
          exclusive
          onChange={handleChange}
        >
          <ToggleButton value="Timetable">Timetable</ToggleButton>
          <ToggleButton value="Events">Events</ToggleButton>
        </ToggleButtonGroup>
      </Stack>
      {view === "Events" ? (
        <Events />
      ) : (
        <Timetable timings={timings} schedule={schedule} disabled />
      )}
    </>
  )
}

const Events = (props) => {
  const calendarRef = useRef(null)
  const [calenderList, setCalenderList] = useState([])

  const getEventsFromProps = () => {
    return calenderList?.map((p) => {
      if (p.eventType === "class") {
        return {
          ...p,
          backgroundColor: "rgba(0, 170, 238, 0.3)",
          textColor: "#000",
          display: "block",
          title: p.courseName,
          start: new Date(p.startTime),
          end: new Date(p.endTime),
        }
      } else if (p.eventType === "assignment") {
        return {
          ...p,
          backgroundColor: "#ffdd42",
          textColor: "#000",
          display: "block",
          title: p.assignmentName,
          id: p.course,
          start: new Date(
            new Date(p.deadLineTime).setHours(
              new Date(p.deadLineTime).getHours() - 1
            )
          ),
          end: new Date(p.deadLineTime),
        }
      } else if (p.eventType === "quiz") {
        return {
          ...p,
          backgroundColor: "#78cf0a",
          textColor: "#000",
          display: "block",
          title: p.assignmentName,
          id: p.course,
          start: new Date(p.startTime),
          end: new Date(p.endTime),
        }
      } else {
        return {
          ...p,
          backgroundColor: "#dee7ee",
          textColor: "#000",
          display: "block",
        }
      }
    })
  }

  const getChild = (data) => {
    var calendarEl = document.getElementById("calendar")
    var calendar = new FCalendar(calendarEl, {
      aspectRatio: 1.8,
      weekends: true,
      contentWidth: "100%",
      height: "auto",
      plugins: [listPlugin, dayGridPlugin, timeGridPlugin, interactionPlugin],

      headerToolbar: {
        left: "prev,next",
        center: "title",
        right: "listYear,timeGridDay,dayGridMonth,timeGridWeek",
        ...props.options,
      },
      views: {
        listYear: { buttonText: "Schedule" },
        timeGridDay: { buttonText: "Day" },
        dayGridMonth: { buttonText: "Month" },
        timeGridWeek: { buttonText: "Week" },
      },
      eventClick: function (info) {
        console.log(info.event)
      },

      defaultView: "listWeek",
      editable: false,
      selectable: false,
      selectMirror: false,
      dayMaxEvents: false,
      customButtons: "",
      initialEvents: data,
      navLinks: true,
      initialView: props.initialView,
    })
    console.log(calendar.getOption("aspectRatio"))
    calendar.render()
    calendarRef.current = calendar
  }

  useEffect(() => {
    getChild(getEventsFromProps())
  }, [calenderList])
  return <div id="calendar"></div>
}

Calendar.propTypes = {
  events: PropTypes.array,
  options: PropTypes.shape({
    right: PropTypes.string.isRequired,
    left: PropTypes.string.isRequired,
  }),
  initialView: PropTypes.string,
}

export default Calendar
